import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EpicCycleCompanyList from '../../RifoDesign/EpicCycleCompanyList/epic.cycle.company.list.vue';
import EpicHeaderBannerText from '../../RifoDesign/EpicHeaderBannerText/epic.header.banner.text.vue';
import {FeatureCycle} from '../../RifoDesign/EpicCycleCompanyList/epic.cycle.company.list.component';
import EpicPageLegendCard from '../../RifoDesign/EpicPageLegendCard/epic.page.legend.card.vue';
import EpicBottomProfile from '../../RifoDesign/EpicBottomProfile/epic.bottom.profile.vue';
import EpicBottomNav from '../../RifoDesign/EpicBottomNav/epic.bottom.nav.vue';
import EpicStandardLayout from '../../layout/EpicStandard/epic.standard.layout.vue';

import { CommonConfig } from '../../configs/config.common';

@Component({
    components: {
        EpicHeaderBannerText,
        EpicCycleCompanyList,
        EpicPageLegendCard,
        EpicBottomProfile,
        EpicBottomNav,
        'layout': EpicStandardLayout
    }
})

export default class EpicAboutUsPage extends Vue {
    public configs = new CommonConfig();
    public title: string = 'EpicAboutUsPage';
    public cycleFeatures!: FeatureCycle[];
    public legendCardLogoUrl: string = '';
    public legendCardParagraph: string = '';
    public mobileBannerUri = `${this.configs.rifoDesignAssetsUrl}/epic-header/bg6.jpg`;
    public created(): void {
        this.legendCardLogoUrl = `${this.configs.rifoDesignAssetsUrl}/epic-about-us/card-logo.png`;
        this.legendCardParagraph = `RIFO is the leading O2O mobile ecological property trading platform in North America.
        Based on our core strength of technology, we offer quality services by enhancing the efficiency of the industrial chain.
        We transform business models ambitiously for traditional real estate sales, value creation, and customer experience enhancement.
        RIFO’s trading platform extends its services to housing services, real estate financial products, and real estate transactions.`;
        this.cycleFeatures = [{
            imgUrl: `${this.configs.rifoDesignAssetsUrl}/epic-about-us/company-logo-1.png`,
            title: 'Rifo Realty'
        }, {
            imgUrl: `${this.configs.rifoDesignAssetsUrl}/epic-about-us/company-logo-2.png`,
            title: 'Eastide Holding Group'
        },
        {
            imgUrl: `${this.configs.rifoDesignAssetsUrl}/epic-about-us/company-logo-3.png`,
            title: 'Queen FINANCE Group'
        }, {
            imgUrl: `${this.configs.rifoDesignAssetsUrl}/epic-about-us/company-logo-4.png`,
            title: 'MASTER’S CHOICE REALTY'
        },
        {
            imgUrl: `${this.configs.rifoDesignAssetsUrl}/epic-about-us/company-logo-5.png`,
            title: 'ROYAL PACIFIC REALTY'
        }, {
            imgUrl: `${this.configs.rifoDesignAssetsUrl}/epic-about-us/company-logo-6.png`,
            title: 'Homeart REALTY'
        },
        {
            imgUrl: `${this.configs.rifoDesignAssetsUrl}/epic-about-us/company-logo-8.png`,
            title: 'Kestrel CAPITAL'
        },
        {
            imgUrl: `${this.configs.rifoDesignAssetsUrl}/epic-about-us/company-icon-a-1.png`,
            title: 'Eastide REALTY'
        },
        // {
        //     imgUrl: `${this.configs.rifoDesignAssetsUrl}/epic-about-us/company-logo-10.png`,
        //     title: 'AIM HOME REALTY'
        // },
        {
            imgUrl: `${this.configs.rifoDesignAssetsUrl}/epic-about-us/company-logo-11.png`,
            title: 'BAIM CAPITAL'
        }, {
            imgUrl: `${this.configs.rifoDesignAssetsUrl}/epic-about-us/company-logo-12.png`,
            title: 'RED FUND CAPITAL'
        },
        {
            imgUrl: `${this.configs.rifoDesignAssetsUrl}/epic-about-us/company-logo-13.png`,
            title: 'REALJAJA GROUP'
        },
        {
            imgUrl: `${this.configs.rifoDesignAssetsUrl}/epic-about-us/company-icon-a-2.png`,
            title: 'unilife REALTY'
        },
        {
            imgUrl: `${this.configs.rifoDesignAssetsUrl}/epic-about-us/company-icon-a-3.png`,
            title: 'realty alliance'
        },
        {
            imgUrl: `${this.configs.rifoDesignAssetsUrl}/epic-about-us/company-icon-a-4.png`,
            title: 'green team REALTY'
        }, {
            imgUrl: `${this.configs.rifoDesignAssetsUrl}/epic-about-us/company-logo-7.png`,
            title: 'Royal ELITE REALTY'
        }, {
            imgUrl: `${this.configs.rifoDesignAssetsUrl}/epic-about-us/company-logo-14.png`,
            title: 'ARTSY HOME STAGING'
        }];
    }
}
